require("../../node_modules/jquery-match-height/dist/jquery.matchHeight.js");

module.exports = {
  init: () => {
    $(".hider").click(function() {
      $(".hider-item").toggleClass("hider-item--hidden");
      $(".hider").toggleClass("hider--hidden");
      $(".matchheight2").matchHeight();
      return false;
    });
  }
};
